/* @flow */
import * as React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../../routes';
import './style.scss';

const Button = ({
  to,
  disabled,
  className,
  size,
  children,
  external,
  action,
  onClick,
  submit,
  loading
}) => {
  if (external) {
    return (
      <a
        href={to}
        disabled={disabled}
        className={`button button-${size} ${className}`}
      >
        {children}
      </a>
    );
  }
  if (action) {
    return (
      <button
        type="button"
        onClick={onClick}
        disabled={disabled}
        className={`button button-${size} ${className}`}
      >
        {children}
      </button>
    );
  }
  if (submit) {
    return (
      <>
        <button
          type="submit"
          disabled={disabled}
          className={`button button-${size} ${className}`}
        >
          <div className={loading ? 'button-text is-loading' : 'button-text'}>
            {children}
          </div>
          <div className={`loader-container ${loading ? 'is-loading' : ''}`}>
            <svg className="spinner-container" viewBox="0 0 44 44">
              <circle
                className="path"
                cx="22"
                cy="22"
                r="20"
                fill="none"
                strokeWidth="2"
                stroke="#FFF"
              />
            </svg>
          </div>
        </button>
      </>
    );
  }
  return (
    <Link
      to={to}
      disabled={disabled}
      className={`button button-${size} ${className}`}
    >
      {children}
    </Link>
  );
};

Button.defaultProps = {
  to: '#',
  className: '',
  size: 'medium',
  disabled: false,
  external: false,
  action: false,
  submit: false,
  loading: false,
  onClick: () => {}
};

Button.propTypes = {
  to: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  size: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  external: PropTypes.bool,
  action: PropTypes.bool,
  submit: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func
};

export default Button;
